import iconDictionary from '../../../../utils/iconDictionary';

const CalendarIcon = iconDictionary('calculatorsCalendar');
const ClockIcon = iconDictionary('calculatorsClock');
const PiggybankIcon = iconDictionary('calculatorsPiggybank');

export const ICON_ARRAY = [CalendarIcon, ClockIcon, PiggybankIcon];
